import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AppLayout from './AppLayout';

const CustomerThankYou = () => {
  const navigate = useNavigate();
  const { applicationId } = useParams();

  return (
    <AppLayout>
      <div style={styles.box}>
        <h1 style={styles.title}>Thanks, your quote request is submitted.</h1>
        <p style={styles.text}>
          Application ID: <b>{applicationId}</b>
        </p>
        <p style={styles.text}>
          Our consultant will verify your application and send your quote to your email.
        </p>

        <div style={styles.actions}>
          <button style={styles.primaryButton} onClick={() => navigate('/')}>
            Back to Home
          </button>
          <button style={styles.secondaryButton} onClick={() => navigate('/quote/start')}>
            Start Another Quote
          </button>
        </div>
      </div>
    </AppLayout>
  );
};

const styles = {
  box: {
    background: '#f7fcf8',
    border: '1px solid #d8e9df',
    borderRadius: 12,
    maxWidth: 680,
    padding: '28px 24px',
  },
  title: {
    color: '#1f6f52',
    fontSize: 31,
    margin: '0 0 10px 0',
  },
  text: {
    color: '#446a56',
    fontSize: 16,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
    marginTop: 14,
  },
  primaryButton: {
    background: 'linear-gradient(90deg, #1f845b 0%, #2da56f 100%)',
    border: 'none',
    borderRadius: 8,
    color: '#fff',
    cursor: 'pointer',
    fontSize: 15,
    fontWeight: 700,
    padding: '11px 18px',
  },
  secondaryButton: {
    background: '#fff',
    border: '1px solid #bdd8c7',
    borderRadius: 8,
    color: '#236946',
    cursor: 'pointer',
    fontSize: 15,
    fontWeight: 700,
    padding: '11px 18px',
  },
};

export default CustomerThankYou;
